module.exports = __webpack_public_path__ + "static/media/mind-garden.715249fa.jpg";